import FooterBottomBox from './FooterBottomBox';

export default FooterBottomBox;
